module.exports = __webpack_public_path__ + "static/img/count-down-bg.878d632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/count-down-bg.jpg
// module id = 0ih6
// module chunks = 1